(function () {
  const OPEN_DELAY_MS = 150;
  const CLOSE_DELAY_MS = 200;
  const DESKTOP_BREAKPOINT = 990;

  const isDesktop = () => window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches;

  document.querySelectorAll('.header__cases-mega-more-button').forEach((button) => {
    const column = button.closest('.header__cases-mega-column');

    if (!column) return;

    button.addEventListener('click', () => {
      const isExpanded = column.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(isExpanded));
      button.textContent = isExpanded ? 'Less' : 'More';
    });
  });

  document.querySelectorAll('details[data-mega-menu]').forEach((details) => {
    const summary = details.querySelector('summary');
    const wrapper = details.closest('li');

    if (!summary || !wrapper) return;

    let openTimer;
    let closeTimer;

    const clearTimers = () => {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }

      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    const openMenu = () => {
      if (!isDesktop()) return;
      clearTimers();
      if (details.hasAttribute('open')) return;

      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = (force = false) => {
      if (!force && !isDesktop()) return;
      const headerMenu = details.closest('header-menu');
      if (headerMenu && typeof headerMenu.close === 'function') {
        headerMenu.close();
        summary.setAttribute('aria-expanded', 'false');
        return;
      }

      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    };

    const toggleMenu = () => {
      if (!isDesktop()) return;

      if (details.hasAttribute('open')) {
        closeMenu();
        return;
      }

      openMenu();
    };

    const scheduleOpen = () => {
      if (!isDesktop()) return;
      clearTimers();
      openTimer = setTimeout(openMenu, OPEN_DELAY_MS);
    };

    const scheduleClose = () => {
      if (!isDesktop()) return;
      clearTimers();
      closeTimer = setTimeout(() => {
        if (!wrapper.matches(':hover') && !wrapper.contains(document.activeElement)) {
          closeMenu();
        }
      }, CLOSE_DELAY_MS);
    };

    wrapper.addEventListener('mouseenter', scheduleOpen);
    wrapper.addEventListener('focusin', scheduleOpen);
    wrapper.addEventListener('mouseleave', scheduleClose);
    wrapper.addEventListener('focusout', scheduleClose);

    summary.addEventListener('click', (event) => {
      if (!isDesktop()) return;
      event.preventDefault();
      toggleMenu();
    });

    summary.addEventListener('keydown', (event) => {
      if (!isDesktop()) return;
      if (event.code === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        toggleMenu();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!isDesktop()) return;
      if (event.code === 'Escape') {
        closeMenu();
      }
    });

    window.addEventListener('resize', () => {
      if (!isDesktop()) {
        clearTimers();
        closeMenu(true);
      }
    });
  });
})();
